import BlockContainerAction from "../../actions/blockContainerAction";
import { useEditorStateContext } from "../../contexts/EditorContext";
import { drawPathFromCoord } from "../../utils/drawPath";

function usePathTmp() {

    const { resetTmpPath : resetTmpPathAction} = BlockContainerAction();

    const { mouse, pathTmp, magnetPosition } = useEditorStateContext();

    const movePathTmp = (x, y, scale) => {
        // magnetPosition containt the position of the block that you are currently hovering if you hover one
        let conditionMagnet = magnetPosition.on && pathTmp.parent_block_id != magnetPosition.id;
        
        // Calculate the offset : couple (x,y) is the beggining of the path so we need to calculate the offset beetween the start and the new coordiate
        // Todo we need no 'smooth' the (x,y) coordinate because the start is where the user click so a little offset can be created and caused visual problem
        let diff = {
            x : x - mouse.x,
            y : y - mouse.y 
        }

        let _x =  conditionMagnet ? magnetPosition.x : pathTmp.x + diff.x / scale
        let _y =  conditionMagnet ? magnetPosition.y : pathTmp.y + diff.y / scale

        let pathRef = document.getElementById("path_tmp"); 
        const {data,stroke} = drawPathFromCoord(pathTmp.x, pathTmp.y, _x, _y)
        pathRef.setAttributeNS(null, 'd', data);
        pathRef.setAttributeNS(null, 'stroke', conditionMagnet ? "var(--main)" : stroke);
    }
    
    const deletePathTmp = (classList) => {
        // Only delete if the pathTmp if class of element clicked is not one them
        const classNames = ["sub_out_block", "sub_out_block_zero", "blocks", "in_block "];
        if(classNames.some(className => classList.contains(className))) return null;
        resetTmpPathAction();
    }

    return { movePathTmp, deletePathTmp, pathTmp, magnetPosition, mouse }
}

export default usePathTmp;